import { writable } from 'svelte/store';

const defaultColors = [
  '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', 
  '#9966FF', '#FF9F40', '#C9CBCF', '#7FCA9F',
  '#66CC99', '#FB8072', '#80B1D3', '#FDB462',
  '#B3DE69', '#FCCDE5', '#D9D9D9', '#BC80BD'
];

function createWheelStore() {
  const { subscribe, update, set } = writable({
    names: [],
    colors: defaultColors
  });
  
  return {
    subscribe,
    
    addName: (name) => {
      update(state => {
        if (!state.names.includes(name)) {
          return {
            ...state,
            names: [...state.names, name]
          };
        }
        return state;
      });
    },
    
    addNames: (newNames) => {
      update(state => {
        // Filter out duplicates
        const uniqueNewNames = newNames.filter(name => !state.names.includes(name));
        
        return {
          ...state,
          names: [...state.names, ...uniqueNewNames]
        };
      });
    },
    
    removeName: (index) => {
      update(state => {
        const newNames = [...state.names];
        newNames.splice(index, 1);
        
        return {
          ...state,
          names: newNames
        };
      });
    },
    
    setNames: (names) => {
      update(state => ({
        ...state,
        names
      }));
    },
    
    clearNames: () => {
      update(state => ({
        ...state,
        names: []
      }));
    },
    
    setColors: (colors) => {
      update(state => ({
        ...state,
        colors
      }));
    },
    
    reset: () => {
      set({
        names: [],
        colors: defaultColors
      });
    }
  };
}

export const wheelStore = createWheelStore();